import script from "./ProductBarcode.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBarcode.vue?vue&type=script&setup=true&lang=js"

import "./ProductBarcode.vue?vue&type=style&index=0&id=57e5fbf7&lang=css"

const __exports__ = script;

export default __exports__